import { isPublicGraphQLOperation } from './graphql-public-operations';

export const isExpectedAuthGraphqlError = (
  message: string,
  operationName: string,
  extensions?: Record<string, unknown>,
): boolean => {
  const normalized = message.toLowerCase();

  if (
    normalized.includes('missing authorization header') ||
    normalized.includes('authentication token not available') ||
    normalized.includes('unauthorized: token is expired')
  ) {
    return true;
  }

  if (isPublicGraphQLOperation(operationName) && extensions?.code === 'UNAUTHENTICATED') {
    return true;
  }

  return false;
};

export const isExpectedAuthNetworkError = (message: string): boolean => {
  const normalized = message.toLowerCase();
  return (
    normalized.includes('authentication token not available') || normalized.includes('missing authorization header')
  );
};
